import { create } from 'zustand';

type SnackbarState = {
  visible: boolean;
  message: string;
  severity: 'success' | 'error' | 'info' | 'warning';
  showSnackbar: (
    message: string,
    severity: SnackbarState['severity'],
    maxWidth?: string
  ) => void;
  hideSnackbar: () => void;
  maxWidth?: string;
};

export const useSnackbarStoreComponent = create<SnackbarState>((set) => ({
  visible: false,
  message: 'la',
  severity: 'info',
  showSnackbar: (message, severity, maxWidth) =>
    set({
      visible: true,
      message,
      severity,
      maxWidth,
    }),
  hideSnackbar: () =>
    set({
      visible: false,
      message: '',
      severity: 'info',
    }),
}));
